/**
 * Card Async Reducer
 */

import { Reducer } from "redux";
import { IHelpersActionCreator } from "root/store/helpers/ActionCreators";
import { Actions } from "root/store/helpers/Actions";

export interface IHelpersState {
  showModalLanguage: boolean;
}

const initialState: IHelpersState = {
  showModalLanguage: false,
};

const HelpersReducer: Reducer<IHelpersState> = (
  state: IHelpersState = initialState,
  action: IHelpersActionCreator
): IHelpersState => {
  if (action.type === Actions.SET_SHOW_LANGUAGE_MODAL)
    return {
      ...state,
      showModalLanguage: action.payload,
    };

  return state;
};

export { HelpersReducer };



// WEBPACK FOOTER //
// ./src/store/helpers/Reducer.tsx